module.exports = "/images/vendor/flag-icon-css/flags/1x1/tn.svg?fea87146ed08572e8a492974c932140e";